/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
export const environment = {
  production: true,
  apiUrl: 'https://localhost:8000/api',
  recaptchaSiteKey: '6Lf5GOItAAAAABhdVczdwtFxKRDKLGXM3udILpd1',
  defaultLang: 'en',
  buildInfo: {
    date: '2026-11-04',
    version: '2.3.0',
    pipelineRun: '2026-11-04.06'
  },
};
